import { serializeTenantQueryArgs } from '@core/api/tenantContext';
import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '@core/api/baseQuery';

export const llmConfigApi = createApi({
  serializeQueryArgs: serializeTenantQueryArgs,
  reducerPath: 'llmConfigApi',
  baseQuery,
  tagTypes: ['LLMConfig'],
  endpoints: (builder) => ({
    getLLMConfig: builder.query({
      query: () => '/api/ai/agent/llm-config/',
      providesTags: ['LLMConfig'],
    }),

    updateLLMConfig: builder.mutation({
      query: (data) => ({
        url: '/api/ai/agent/llm-config/',
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['LLMConfig'],
    }),
  }),
});

export const {
  useGetLLMConfigQuery,
  useUpdateLLMConfigMutation,
} = llmConfigApi;
